import { SyntheticEvent, useEffect, useRef } from 'react';
import styles from './style.module.scss';

export interface InputBoxProps {
  id: string;
  type?: string;
  value?: string;
  placeholder?: string;
  minLength?: number;
  maxLength?: number;
  readOnly?: boolean;
  disabled?: boolean;
  required?: boolean;
  onClick?: (event: SyntheticEvent) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  classNames?: string;
  defaultStyle?: boolean;
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  shouldPreventScroll?: boolean;
}

const InputBox = (props: InputBoxProps) => {
  const {
    classNames,
    type,
    defaultStyle = true,
    maxLength,
    minLength,
    shouldPreventScroll,
    ...otherProps
  } = props;

  const classes = `w-full h-full p-4 relative rounded-cxs ${styles.input} ${classNames} ${
    defaultStyle && 'border border-gray-300'
  }`;

  const inputRef = useRef(null);

  useEffect(() => {
    if (shouldPreventScroll) {
      const handleWheel = (e: any) => {
        if (inputRef.current === document.activeElement) {
          /* istanbul ignore next */
          e.preventDefault();
        }
      };

      if (inputRef && inputRef.current) {
        const inputElement = inputRef.current;
        // @ts-ignore
        inputElement.addEventListener('wheel', handleWheel);
        // @ts-ignore
        inputElement.addEventListener('mousewheel', handleWheel);

        return () => {
          // @ts-ignore
          inputElement.removeEventListener('wheel', handleWheel);
          // @ts-ignore
          inputElement.removeEventListener('mousewheel', handleWheel);
        };
      }
    }
  }, [shouldPreventScroll]);

  const handleKeyDown = (e: any) => {
    if (shouldPreventScroll) {
      if (
        (e.key === 'ArrowUp' || e.key === 'ArrowDown') &&
        inputRef.current === document.activeElement
      ) {
        /* istanbul ignore next */
        e.preventDefault();
      }
    }
  };

  return (
    <input
      onKeyDown={handleKeyDown}
      ref={inputRef}
      type={type}
      className={classes}
      onInput={(e) =>
        maxLength
          ? ((e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(
              0,
              maxLength,
            ))
          : (e.target as HTMLInputElement).value
      }
      maxLength={maxLength}
      minLength={minLength}
      {...otherProps}
    />
  );
};

InputBox.defaultProps = {
  type: 'text',
  value: undefined,
  placeholder: '',
  minLength: undefined,
  maxLength: undefined,
  readOnly: false,
  disabled: false,
  required: false,
  onClick: () => {},
  onChange: () => {},
  classNames: '',
};

export default InputBox;
